import { _ as __rest, a as __assign } from '../../tslib.es6-18cb2814.js';
import { c as classNames } from '../../index-8887fc24.js';
import * as React from 'react';
import { ClipboardCopy } from './ClipboardCopy.js';
import { TextInput } from './TextInput.js';
import '../../CopyIcon-b295a93f.js';
import '../../countries-34fea817.js';
import '../../index-b7114926.js';
import 'react-router-dom';
import '../../skeleton.module-7c98b8f8.js';
import '../../ThemeProvider-e3ab770b.js';
import '../../useCombinedRefs-56aeb9e7.js';
import '../../useId-f4885202.js';
import './IconButton.js';
import './Typography.js';
import '../../TextInput.module-7e116b65.js';

var styles = {"container":"ClipboardInput_container_3871a3d4","textContainer":"ClipboardInput_textContainer_3871a3d4","textInput":"ClipboardInput_textInput_3871a3d4","visuallyHidden":"ClipboardInput_visuallyHidden_3871a3d4"};

var ClipboardInput = React.forwardRef(function ClipboardInput(props, ref) {
    var className = props.className, _a = props.text, text = _a === void 0 ? "" : _a, onCopy = props.onCopy, onError = props.onError, isSkeleton = props.isSkeleton, isDisabled = props.isDisabled, label = props.label, _b = props.showLabel, showLabel = _b === void 0 ? false : _b, _c = props.buttonColor, buttonColor = _c === void 0 ? "action" : _c, _d = props.noBackground, noBackground = _d === void 0 ? false : _d, otherProps = __rest(props, ["className", "text", "onCopy", "onError", "isSkeleton", "isDisabled", "label", "showLabel", "buttonColor", "noBackground"]);
    return (React.createElement("div", { ref: ref, className: classNames(styles.container, className) },
        React.createElement(TextInput, __assign({ isSkeleton: isSkeleton, className: styles.textContainer, inputClassName: styles.textInput, value: text, readOnly: true, label: label, showLabel: showLabel, disabled: isDisabled }, otherProps)),
        React.createElement(ClipboardCopy, { isSkeleton: isSkeleton, text: text, noBackground: noBackground, color: buttonColor, onCopy: onCopy, onError: onError, isDisabled: isDisabled })));
});

export { ClipboardInput };
